import { useMemo } from "react";
import { KPI_CODES } from "../kpiCodes";
import { useSetMapByGranularity } from "./useSetMapByGranularity";

export const usePayoffAmounts = (data: any) => {
  const { setMap } = useSetMapByGranularity([
    KPI_CODES.PAYOFF_COUNT_TODAY,
    KPI_CODES.PAYOFF_COUNT_THIS_MONTH,
    KPI_CODES.PAYOFF_COUNT_THIS_YEAR,
  ]);

  const payoffAmounts = useMemo(
    () => (data ? setMap(data) : {}),
    [data, setMap],
  );

  return { payoffAmounts };
};
